import type { Action } from "../../actions/types";

export interface CouponRecord {
  coupon: string;
  status: "distributed" | "redeemed";
}

export type StoreState = CouponRecord[];

export const initialState = [];

export function reducer(
  state: StoreState | null = initialState,
  action: Action
): StoreState | null {
  if (action.type === "GET_COUPONS_SUCCESS") {
    return action.response.data.coupons;
  }

  return state;
}
